import React from 'react';

const SectionTitle = React.createClass({
    propTypes: {
        children: React.PropTypes.node.isRequired,
        width: React.PropTypes.string
    },
    render: function() {
        var style = {
            maxWidth: (this.props.width) ? this.props.width : null
        };
        return (
            <div className="container" style={style}>
                {this.props.children}
            </div>
        );
    }
});

export default SectionTitle;



// WEBPACK FOOTER //
// ./src/js/components/Container.js